import { Component, OnInit, ViewChild, inject, signal } from '@angular/core';
import { ShowComponent } from '../common/component/show.component';
import { VehicleDeviceCmaComponent } from './vehicle-device-cma/vehicle-device-cma.component';

import { ConnectBusLayoutsApiService } from '@/connect-bus-layouts/connect-bus-layouts.api.service';
import { Layout } from '@/connect-bus-layouts/connect-bus-layouts.component';
import { HttpClient } from '@angular/common/http';
import { EMPTY, catchError, switchMap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Vehicle } from './vehicle.model';
import { Result } from '@/reservation/reservation.model';

@Component({
	selector: 'app-vehicles',
	templateUrl: './vehicles.component.html',
	styleUrls: ['./vehicles.component.css'],
	providers: [ConnectBusLayoutsApiService],
})
export class VehiclesComponent extends ShowComponent implements OnInit {
	@ViewChild(VehicleDeviceCmaComponent)
	VehicleDeviceCma: VehicleDeviceCmaComponent;
	data: Vehicle = {
		id: null,
		type: null,
		name: null,
		registrationNumber: null,
		inspection: null,
		insurance: null,
		tachographLegalization: null,
		mileage: null,
		lastOilChange: null,
		oilChangeFrequency: null,
		alerts: null,
		lastFiltersChange: null,
		tiresType: null,
		seats: null,
		status: null,
		nawigatorId: null,
		lastLocation: null,
		busType: null,
		premium: null,
		vinNumber: null,
		vehicleMark: null,
		vehicleModel: null,
		yearOfProduction: null,
		wrappingType: null,
		confirmed: [],
		documents: {
			license: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			certificate100km: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			autocasco: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			registrationcard: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			autocassco: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			authtouse: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			greencard: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			insurance: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			exhaustStandards: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			inspection: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			stAt: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			stBe: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			stCh: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			stDk: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			stDe: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			stDeinfo: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			stSlo: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			tachographLegalization: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			axis: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			fuelTanks: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			hook: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			backpack: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			interBus: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			greenBook: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			chains: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			workshopBox: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			placeBackpack: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			toiletStatus: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			isClean: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			vest: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			libra: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			childrensBoard: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			movies: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			headphones: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			busDescription: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			vignetteHungary: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			boxPl: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			boxXs: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			boxAt: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			boxSi: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			boxCz: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			boxSk: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			box: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			seatsType: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			distanceSeats: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			distanceHeadrests: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			chaiseLongue: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			sockets: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			usb: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			internet: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			monitors: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			multimediaSystem: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			microphone: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			safe: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			wifi: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			board: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			tachoRolls: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			aidKit: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			fireExtinguisher: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			butterflies: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			pinCards: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			multimediaSystemDescription: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
			cafeBar: {
				id: null,
				endDate: null,
				type: null,
				checkDocument: null,
				company: null,
				standard: null,
				number: null,
				capacity: null,
				checkHook: null,
			},
		},
	};
	errors = {
		type: '',
		name: '',
		registrationNumber: '',
		status: '',
	};
	tableRows: { id: string; name: string }[] = [
		{ id: 'userConfirm', name: 'Kto zatwierdził' },
		{ id: 'confirmDate', name: 'Data zatwierdzenia' },
	];
	parameters = {
		types: [],
		busTypes: [],
		statuses: [],
		companies: [],
		wrappingTypes: [],
	};
	seatLayout = signal<string>(null);
	seatLayouts = signal<Layout[]>([]);
	bagVehicle = signal(null);

	protected itemsBeforeDataLoad = 5;
	protected parentComponent = 'vehicles';
	protected questionConfirmSubscription;

	private readonly connectBusLayoutsApiService = inject(ConnectBusLayoutsApiService);
	private readonly httpClient = inject(HttpClient);

	ngOnInit(): void {
		super.ngOnInit();
		this.connectBusLayoutsApiService.getTransportLayout('virtual_layout__isnull=false').subscribe((layouts) => {
			this.seatLayouts.set(layouts.results);
		});
	}

	confirmAsk(): void {
		this.question.ask(
			'UWAGA: Zatwierdzasz aktualny stan dokumentów. Czy jesteś pewny/a, że zweryfikowałeś wszystkie pozycje w dokumentach?',
			'confirmAsk',
		);
		this.questionConfirmSubscription = this.question.status.subscribe((result) => {
			if (result.dialogId !== 'confirmAsk') {
				return;
			}
			if (!result.result) {
				return;
			}
			this.api.command('/vehicles/' + this.data.id + '/', {}, (result, error) => {
				if (error) {
					return;
				}
				this.infobox.success('Zatwierdzono zgodność dokumentów dla pojazdu: ' + this.data.name);
			});
		});
	}

	ngOnDestroyOther(): void {
		if (this.questionConfirmSubscription) {
			this.questionConfirmSubscription.unsubscribe();
		}
	}

	protected afterLoadData(): void {
		this.httpClient
			.get(`${environment.apiUrl}/transport/vehicle/?navigator_id=${this.data.nawigatorId}`)
			// eslint-disable-next-line  @typescript-eslint/no-explicit-any
			.subscribe((result: Result<any>) => {
				if (!result || !result.results || !result.results.length) {
					return;
				}
				this.seatLayout.set(result.results[0].layout?.id ?? null);
				this.bagVehicle.set(result.results[0]);
			});
	}

	protected loadBefore(): void {
		this.api.get('/vehicleTypes/', (result) => {
			this.parameters.types = result.data;
			this.loadData();
		});
		this.api.get('/vehicleBusTypes/', (result) => {
			this.parameters.busTypes = result.data;
			this.loadData();
		});
		this.api.get('/vehicleStatuses/', (result) => {
			this.parameters.statuses = result.data;
			this.loadData();
		});
		this.api.get('/company/', (result) => {
			this.parameters.companies = result.data;
			this.loadData();
		});
		this.api.get('/wrappingTypes/', (result) => {
			this.parameters.wrappingTypes = result.data;
			this.loadData();
		});
	}

	protected convertData(data: any): any {
		data.premium = data.premium === '1' ? true : false;
		for (const key in this.data.documents) {
			if (!data.documents[key]) {
				data.documents[key] = {
					id: null,
					endDate: null,
					type: null,
					checkDocument: null,
					company: null,
					standard: null,
					number: null,
					capacity: null,
					checkHook: null,
				};
			}
		}
		const documentKeys = ['registrationcard', 'stAt', 'stBe', 'stCh', 'stDk', 'stSlo', 'stDe', 'stDeinfo'];

		documentKeys.forEach((key) => {
			data.documents[key].checkDocument = data.documents[key].checkDocument === '1';
		});

		return data;
	}

	protected pageTitleGenerate(): string {
		return this.data.lastLocation?.odometer
			? this.data?.name + ' | Stan licznika: ' + this.data.lastLocation?.odometer + ' Km'
			: this.data?.name;
	}

	protected submitAfter(): void {
		this.itemsBeforeDataLoad = 0;
		this.loadData();
	}

	protected submitBefore(): void {
		if (!this.data.nawigatorId) {
			return;
		}
		this.httpClient
			.get<Result<any>>(`${environment.apiUrl}/transport/vehicle/?navigator_id=${this.data.nawigatorId}`)
			.pipe(
				switchMap((result) => {
					const bagVehicle = result?.results?.[0];
					if (!bagVehicle) {
						return EMPTY;
					}
					return this.httpClient.put(`${environment.apiUrl}/transport/vehicle/${bagVehicle.id}/`, {
						...bagVehicle,
						navigator_id: this.data.nawigatorId,
						layout: this.seatLayout(),
						model: bagVehicle.model?.id ?? null,
					});
				}),
				catchError(() => {
					this.infobox.error('Wystąpił błąd podczas aktualizacji pojazdu w BAG');
					return EMPTY;
				}),
			)
			.subscribe();
	}
}
